import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { styles } from './close-button-styles';

export interface ICloseBtnProps {
  clickHandler: () => void;
  classes?: string | undefined;
  dataTestIdPrefix?: string;
}

export const CloseButton: React.FC<ICloseBtnProps> = (props: ICloseBtnProps): JSX.Element => {
  const classes = styles();

  return (
    <BaseButton
      buttonType='white'
      classes={{ root: props.classes }}
      className={classes.closeBtn}
      onClick={props.clickHandler}
      data-testid={
        props.dataTestIdPrefix ? `${props.dataTestIdPrefix}-button-close` : 'base-button-close'
      }
    >
      Close
    </BaseButton>
  );
};
